// extracted by mini-css-extract-plugin
export default {"backdrop":"Alert_backdrop__dAtzw","alert":"Alert_alert__3FHWs"};